module.exports = __webpack_public_path__ + "static/media/cheer.266b2919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cheer.png
// module id = 482
// module chunks = 0